/**
 * @file OperationsLogSheetsPage.jsx
 * @description OPERATIONS department — Log Sheets (the invoice downloader) and
 *              the team's WEEKLY DATA CHECK.
 *
 * Two tabs:
 *   Invoices & Logs   machines on rent in a selected period — export their
 *                     usage logs and invoices (RentalPage's invoiceDownload
 *                     engine, unchanged).
 *   Weekly Data Check the internal check run every week BEFORE those go out:
 *                     is every machine's data for the week right? Auto
 *                     findings per machine, a verdict per machine, a sign-off
 *                     per week (OperationsWeeklyDataCheck).
 *
 * The tab rides the URL (?tab=check) so the check can be linked to directly.
 * The daily ran/not-run report lives on Operations' own Daily Report header.
 *
 * This file belongs to the OPERATIONS department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for OPERATIONS is made HERE and can never leak into another
 * department's screens. The shared engine underneath (RentalPage's
 * invoiceDownload view) and the backend stay common.
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import { ReceiptLong as InvoicesIcon, FactCheck as CheckIcon } from '@mui/icons-material';
import RentalPage from '../RentalPage';
import OperationsWeeklyDataCheck from './OperationsWeeklyDataCheck';

const TABS = [
    { key: 'invoices', label: 'Invoices & Logs', Icon: InvoicesIcon },
    { key: 'check', label: 'Weekly Data Check', Icon: CheckIcon },
];

const OperationsLogSheetsPage = () => {
    const [params, setParams] = useSearchParams();
    const tab = TABS.some(t => t.key === params.get('tab')) ? params.get('tab') : 'invoices';
    const setTab = (key) => {
        const next = new URLSearchParams(params);
        if (key === 'invoices') next.delete('tab'); else next.set('tab', key);
        setParams(next, { replace: true });
    };

    return (
        <Box sx={{ p: { xs: 2, md: 3 } }} className="animate-fade-in">
            <Tabs value={tab} onChange={(_e, v) => setTab(v)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
                {TABS.map(t => (
                    <Tab key={t.key} value={t.key} label={t.label} icon={<t.Icon fontSize="small" />} iconPosition="start"
                        sx={{ textTransform: 'none', fontWeight: 700, minHeight: 44 }} />
                ))}
            </Tabs>
            {tab === 'check'
                ? <OperationsWeeklyDataCheck />
                : <RentalPage embedded forcedView="invoiceDownload" />}
        </Box>
    );
};

export default OperationsLogSheetsPage;
